import Typography from '@/common/components/base/typography/Typography.tsx';
import { css } from 'styled-system/css';

export default () => (
  <Typography
    borderRadius="4px"
    backgroundColor="pink-2"
    textStyle="b4"
    px="10px"
    py="2px"
    display="flex"
    alignItems="center"
  >
    <span
      className={css({
        ml: '5px',
        w: '6px',
        h: '6px',
        backgroundColor: 'pink',
        borderRadius: '50%',
      })}
    />
    خسارت ثالث
  </Typography>
);
